/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateThreadComment = /* GraphQL */ `
  subscription OnCreateThreadComment($decisionId: String, $threadId: String) {
    onCreateThreadComment(decisionId: $decisionId, threadId: $threadId) {
      id
      threadId
      decisionId
      replyingTo
      comment
      userId
      tags
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteThreadComment = /* GraphQL */ `
  subscription OnDeleteThreadComment($decisionId: String, $threadId: String) {
    onDeleteThreadComment(decisionId: $decisionId, threadId: $threadId) {
      id
      threadId
      decisionId
      replyingTo
      comment
      userId
      tags
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateThreadComment = /* GraphQL */ `
  subscription OnUpdateThreadComment($decisionId: String, $threadId: String) {
    onUpdateThreadComment(decisionId: $decisionId, threadId: $threadId) {
      id
      threadId
      decisionId
      replyingTo
      comment
      userId
      tags
      createdAt
      updatedAt
    }
  }
`;
export const onCreateComment = /* GraphQL */ `
  subscription OnCreateComment($decisionId: String) {
    onCreateComment(decisionId: $decisionId) {
      id
      threadId
      decisionId
      replyingTo
      comment
      userId
      tags
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteComment = /* GraphQL */ `
  subscription OnDeleteComment($decisionId: String) {
    onDeleteComment(decisionId: $decisionId) {
      id
      threadId
      decisionId
      replyingTo
      comment
      userId
      tags
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateComment = /* GraphQL */ `
  subscription OnUpdateComment($decisionId: String) {
    onUpdateComment(decisionId: $decisionId) {
      id
      threadId
      decisionId
      replyingTo
      comment
      userId
      tags
      createdAt
      updatedAt
    }
  }
`;
export const onCreateThread = /* GraphQL */ `
  subscription OnCreateThread($decisionId: String) {
    onCreateThread(decisionId: $decisionId) {
      id
      decisionId
      resourceId
      secondaryResourceId
      tertiaryResourceId
      comments {
        items {
          id
          threadId
          decisionId
          replyingTo
          comment
          userId
          tags
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteThread = /* GraphQL */ `
  subscription OnDeleteThread($decisionId: String) {
    onDeleteThread(decisionId: $decisionId) {
      id
      decisionId
      resourceId
      secondaryResourceId
      tertiaryResourceId
      comments {
        items {
          id
          threadId
          decisionId
          replyingTo
          comment
          userId
          tags
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
